// extracted by mini-css-extract-plugin
export var active = "bz_bd";
export var categories = "bz_cS";
export var category = "bz_cT";
export var icon = "bz_bz";
export var icons = "bz_bS";
export var image = "bz_d";
export var member = "bz_gl";
export var memberTitle = "bz_gm";
export var name = "bz_fx";
export var placeholder = "bz_bb";
export var section = "bz_b";
export var show = "bz_L";
export var subtitle = "bz_ck";
export var team = "bz_gk";